module.exports = __webpack_public_path__ + "lap.png?f1dd1634eb79f4f905864fc10bfa3e32";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lap.png
// module id = 94
// module chunks = 0